































import { Vue, Component } from 'vue-property-decorator';
import VoteButton from '../../components/VoteButton.vue';
import * as config from './config';
import { getdetail } from './api';
@Component({
  name: 'DetailPage',
  components: {
    VoteButton,
  },
})
export default class DetailPage extends Vue {
  imgUrl: string = require('./img/banner.jpg');
  option = config.OPTHINES;
  detailData = {};
  get name() {
    return this.$route.query.name;
  }
  created() {
    getdetail(
      this.option.voteName,
      this.name,
      Number(this.$route.query.id),
    ).then((res: any) => (this.detailData = res.data));
  }

  votSuccess(res: any) {
    console.log(res);
    getdetail(
      this.option.voteName,
      this.name,
      Number(this.$route.query.id),
    ).then((res: any) => (this.detailData = res.data));
  }
}
